import React from "react";
import "../css/AdditionalDetails.css";
import addPhoto from "../images/addPhoto.png";
import advancedDetails from "../images/advancedDetails.png";
import verify from "../images/verify.png";
import returnHome from "../images/return.png";
import { useNavigate } from "react-router-dom";

export default function AdvancedDetails() {
  const navigate = useNavigate();
  return (
    <div className="exterior1">
    sdfdfsd
    
    <div className="property-container">
      <div className="property-left-box">
        <div className="property-header">
          <p className="property-title">Congratulations! Your Property Is Under Review.</p>
          <p className="property-subtitle">
            Meanwhile, You Can Add Photos & Other Additional <br /> Details To Receive More Enquiries.
          </p>
        </div>
        <div className="property-options-box">
        <div className="options-cat">
    <img src={returnHome} alt="Return to Dashboard" />
    <button className="options-cat-name" 
    onClick={() => navigate('/')}>
      Return To Dashboard</button>
  </div>
  <div className="options-cat">
    <img src={addPhoto} alt="Add Photos/Videos" />
    <button className="options-cat-name"
    onClick={() => navigate('/additionalDetails')}>
      Add Photos/Videos</button>
  </div>
  <div className="options-cat">
    <img src={advancedDetails} alt="Advanced Details" />
    <button className="options-cat-name"
    onClick={() => navigate('/advancedDetails')}>
      Advanced Details</button>
  </div>
  <div className="options-cat">
    <img src={verify} alt="Verify Your Property" />
    <button className="options-cat-name"
    onClick={() => navigate('/verifyProperty')}>
      Verify Your Property</button>
  </div>
</div>
      </div>
      <div className="property-right-box">
        
    <div className="rightBox-title">
      <div>Add Advanced Details</div>
      <div><button className="rbButton"  onClick={() => navigate('/verifyProperty')}> Skip&gt;&gt;</button> </div>
      
    </div>
    <div className="formBody1">
            <div className='formRow'>
            <input type="text" placeholder="Age of Property (In Years )" className="textField1"/>
            <select className="dropdown1">
                <option>Facing</option>
              </select>
    
            </div>

            <div className="formRow">
              <input type="text" placeholder="Plot Area (Sq. Ft)" className="textField" />
              <input type="number" placeholder='Carpet Area ' className='textField'/>
            </div>
            <div className="formRow">
              <select className="dropdown">
                <option>Bathroom</option>
              </select>
              <select className="dropdown">
                <option>Balcony</option>
              </select>
            </div>

            <div className="formRow">
              <select className="dropdown">
                <option>Covered Parking</option>
              </select>
              <select className="dropdown">
                <option>Open Parking</option>
              </select>
            </div>

            <div className="formRow">
              <select className="dropdown">
                <option>Servant Room</option>
              </select>
              <select className="dropdown">
                <option>Brokerage And Loan</option>
              </select>
            </div>

            <div className='formRow'>
            <input type="text" placeholder="RERA Id" className="textField1"/>
            <select className="dropdown1">
                <option>Registration</option>
              </select>
    
            </div>

            <div className="formRow">
              <input type="text" placeholder="Address" className="textField" />
              <input type="number" placeholder='Property Description ' className='textField'/>
            </div>
            <div className="ribbon">
              <button className="ribbonText" onClick={() => navigate('/verifyProperty')}>Save</button>
            </div>
        </div>
        
      </div>
     
    </div>
    </div>
  );
}